import { FavoritesRequestBody } from 'pages/avia/favorites/hooks/types.ts'

import { mapSearchDirectionsForRequest } from 'entities/ticket/lib/map-search-directions-for-request'

import { FavoriteRequestData } from 'shared/api/avia/favorites'

interface Props {
  favoritesSearchKey: string
  favoritesParams: FavoritesRequestBody
}

export const prepareDataForFavorite = ({
  favoritesSearchKey,
  favoritesParams,
}: Props): FavoriteRequestData => {
  const { params, directions } = favoritesParams

  return {
    request_data: {
      directions: mapSearchDirectionsForRequest(directions),
      params,
    },
    favorite_search_key: favoritesSearchKey,
  }
}
